import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useForm, FormProvider } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { DatePicker } from "antd";
import {
    ChangeEvent,
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import moment, { Moment } from "moment";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarClassesControlesDirecionamentoController } from "../../../../Controllers/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamento";
import SeletorCategoriaAtendimento from "../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    ICadastroDeDirecionamento,
    IDirecionamentoPayload,
} from "../../../../Interfaces/AssistenciaTecnica/CadastroDeDirecionamento/CadastroDeDirecionamentoInterface";
import Select from "react-select";

interface IFiltroDirecionamento {
    handleFilterFormSubmit(formData: IDirecionamentoPayload): void;
    filtroInicial: IDirecionamentoPayload;
    ano: string;
    mes: string;
    filter: IDirecionamentoPayload | undefined;
    setPage: (page: number) => void;
    setMes: Dispatch<SetStateAction<string>>;
    setAno: Dispatch<SetStateAction<string>>;
    setIdCategoriaPai: Dispatch<SetStateAction<number>>;
    setFilter: (filter: any) => void;
    setDsEmpreendimento: Dispatch<SetStateAction<string | undefined>>;
}

export default function FiltroDirecionamento(props: IFiltroDirecionamento) {
    const formMethods = useForm();

    const { reset, control } = formMethods;

    const { id } = useModuloInfo();

    function geradorMascaraFinanceira(
        inputName: keyof ICadastroDeDirecionamento
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    function onChangeAno(date: Moment | null, dateString: string) {
        props.setAno(dateString);
    }

    function onChangeMes(date: Moment | null, dateString: string) {
        props.setMes(dateString);
    }

    const limparFiltros = () => {
        props.setAno("");
        props.setMes("");
        props.setIdCategoriaPai(0);
        praca.current?.clearValue();
    };

    const { value: lstEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    function formatadorDatas(inputName: keyof ICadastroDeDirecionamento) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            let data: string | string[] = e.target.value;

            if (data.length !== 10) {
                let nvDate: string | string[] = data.split("-");
                nvDate[0] = nvDate[0].substring(1, 5);
                nvDate = nvDate.join("-");
                data = nvDate;
            }

            formMethods?.setValue(inputName, moment(data).format("YYYY-MM-DD"));
        };
    }

    const praca = useRef<any>(null);

    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    useEffect(() => {
        setOptions(() =>
            lstEmpreendimentos
                ?.filter((lst) => lst.DS_ESTADO !== null)
                ?.map((empreendimento) => ({
                    label: empreendimento.DS_EMPREENDIMENTO,
                    value: empreendimento.ID_EMPREENDIMENTO,
                }))
        );
    }, [lstEmpreendimentos]);

    return (
        <FormProvider {...formMethods}>
            <UnForm handleSubmit={props.handleFilterFormSubmit} usingContext>
                <label>Classificação / Sub-Assunto</label>
                <SeletorCategoriaAtendimento
                    showPlaceholder
                    ID_MODULO={id}
                    setIdCategoria={(c) => props.setIdCategoriaPai(c as number)}
                    filterTreeNode={(input, treeNode) =>
                        treeNode?.props.title
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    defaultValue={props.filter?.ID_SUBASSUNTO}
                    control={control}
                    name="ID_SUBASSUNTO"
                />

                <UnForm.LazySelect
                    label="Classe Controle Direcionamento"
                    name="DS_CLASSE_CONTROLE"
                    controller={ListarClassesControlesDirecionamentoController}
                    getDS={(ds) => ds.DS_CLASSE_CONTROLE_DIRECIONAMENTO}
                    getKeyValue={(key) => key.DS_CLASSE_CONTROLE_DIRECIONAMENTO}
                    defaultValue={props.filter?.DS_CLASSE_CONTROLE}
                >
                    <option></option>
                </UnForm.LazySelect>

                <label>Residencial</label>
                <Select
                    name="DS_PRODUTO"
                    ref={praca}
                    options={options}
                    isClearable
                    onChange={(e) => {
                        props.setDsEmpreendimento(e?.label ? e.label : "");
                    }}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    styles={customStyles}
                    placeholder={""}
                    noOptionsMessage={() => "Nenhuma opção"}
                    className="mb-3"
                />

                <UnForm.Input
                    label="Valor total"
                    name="VL_VALOR"
                    registerOptions={{
                        setValueAs: (v: string) => {
                            return Number(MoneyReaisFieldMask.unMask(v));
                        },
                    }}
                    onChange={geradorMascaraFinanceira("VL_VALOR")}
                    defaultValue={props.filter?.VL_VALOR}
                />
                <UnForm.Input
                    className="mb-4"
                    label="Data"
                    name="DATA"
                    onChange={formatadorDatas("DATA")}
                    type="date"
                    defaultValue={props.filter?.DATA}
                ></UnForm.Input>
                <label>Mês</label>
                <DatePicker
                    picker="month"
                    onChange={onChangeMes}
                    className="form-control mb-3"
                    placeholder=""
                    format={"MM"}
                    value={props.mes ? moment(props.mes, "MM") : null}
                    defaultValue={moment(props.filter?.NR_MES, "MM")}
                />

                <label>Ano</label>
                <DatePicker
                    picker="year"
                    onChange={onChangeAno}
                    className="form-control mb-3"
                    placeholder=""
                    value={props.ano ? moment(props.ano, "YYYY") : null}
                    defaultValue={moment(props.filter?.NR_ANO, "YYYY")}
                />

                <UnForm.SubmitButton
                    className="w-100"
                    wrapperClassName="w-100 d-flex align-items-end justify-content-start mt-3"
                    icon={faFilter}
                    color="dark"
                    outline
                >
                    Filtrar
                </UnForm.SubmitButton>
                <button
                    type="button"
                    onClick={() => {
                        window.sessionStorage.removeItem(
                            "FILTRO_CUSTOS_ENCARREGADO"
                        );
                        props.setFilter(props.filtroInicial);
                        reset(props.filtroInicial);
                        props.setPage(1);
                        limparFiltros();
                    }}
                    className="btn btn-block btn-outline-danger mt-2"
                >
                    <FontAwesomeIcon icon={faTimes} className="mr-2" />
                    Limpar Filtros
                </button>
            </UnForm>
        </FormProvider>
    );
}
